import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryPopupComponent } from './story-popup.component';
import { StoryV3BannerModule } from '../story-v3-banner/story-v3-banner.module';
import { MatIconModule } from '@angular/material/icon';
import { DonateNowModule } from '../donate-now/donate-now.module';



@NgModule({
  declarations: [
    StoryPopupComponent
  ],
  imports: [
    CommonModule,
    StoryV3BannerModule,
    MatIconModule,
    DonateNowModule
  ],
  exports: [StoryPopupComponent],
  bootstrap: [StoryPopupComponent]
})
export class StoryPopupModule { }
